import * as React from 'react';

import { Messages } from '../../../../../codegen/Localize';
import { FormikTextBox } from '../../../../../commonInfra/components/FormikField';
import { useFormikContext } from '../../../../FormikWrapperForStubbing';
import { narrowTextFieldStyle } from '../../../../styles/CommonStyles';
import { useCompositeValidator, usePositiveIntegerValidator, useRangeValidator, useValidatorWithDisable } from '../../../utils';
import { LicenseMaxCounts } from './ManageUsersAdminsOption';
import { ManageUsersSectionProps } from './ManageUsersSection';

export const USER_QUOTA_FIELD = 'settings.userQuota';

export function ManageUsersSiteUserQuotaOption(props: ManageUsersSectionProps & { maxCounts: LicenseMaxCounts }) {
  const formik = useFormikContext<ManageUsersSectionProps>();

  const disabled = !formik.values.settings.siteAdminsCanAddUsers;

  const validate = useQuotaValidator(disabled,
    props.siteInfo.licensedUserCount, Messages.userLimitMustBeGreaterThanUserCount,
    props.maxCounts?.userCountMax ?? Number.MAX_VALUE, Messages.userLimitMustBeLessThanLicenseCount
  );

  return <>
    <div>{Messages.siteLimit()}</div>
    {formik.values.settings.userQuotaMode === 'site-user-quota' &&
    <FormikTextBox testId={'user-quota-input'}
                   name={USER_QUOTA_FIELD}
                   label={Messages.siteLimitDescription()}
                   validate={validate}
                   disableOnSubmit={true}
                   className={narrowTextFieldStyle}
                   disabled={disabled}
                   value={formik.values.settings.userQuota ?? ''}
                   maxLength={9}
    />}
  </>;
}

export function useQuotaValidator(disabled: boolean,
                           min: number, minMessage: () => string,
                           max: number, maxMessage: () => string) {
  return useValidatorWithDisable(disabled,
    useCompositeValidator(
      usePositiveIntegerValidator(Messages.userLimitMustBePositiveInteger),
      useRangeValidator(min, minMessage, max, maxMessage)
    )
  );
}
